import { Container } from 'react-bootstrap';
import HealthCareFilter from '../../Forms/healthCareFilter/HealthCareFilter';
import { HeadingDesc } from '../../Headings';
import { SectionHeading } from '../../SectionHeading';
import TypingAnimation from '../../typingAnimation/TypingAnimation';
import './bannerWithSearchBar.css';

function BannerWithSearchBar() {
  return (
    <div className="bannerWithSearchBar">
      <Container>
        <SectionHeading
          heading="Find the best"
          colorHeading={<TypingAnimation />}
        />
        <HeadingDesc text="1 Million+ Patients Found Doctors For Them Through Meri Sehat!" />
        <HealthCareFilter />
      </Container>
    </div>
  );
}

export default BannerWithSearchBar;
